import { CircularProgress } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import "./PropertyFilter.scss";
import { useSearchParams } from "react-router-dom";
import { PropertyApi } from "../../../../utils/api/Property";
import SearchIcon from "../../../../components/icons/SearchIcon";
import RoundRemoveIcon from "../../../../components/icons/RoundRemoveIcon";
import DownArrowIcon from "../../../../components/icons/DownArrowIcon";

interface Property {
  _id: string;
  property_address: string;
  name?: string;
}

const FilterPropertySelect = ({ formik }: { formik: any }) => {
  const [state, setState] = useState({
    isLoading: true,
    showDropdown: false,
    properties: [],
    search: "",
  });
  const [searchParams] = useSearchParams();
  const containerRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = () => {
    setState((prev) => ({ ...prev, showDropdown: !prev.showDropdown }));
  };

  const onClickSelect = (property: Property) => {
    formik.setFieldValue("selectedPropertyId", property._id);
    formik.setFieldValue("selectedProperty", property);
    setState((prev) => ({ ...prev, showDropdown: false }));
  };

  const removeSelected = () => {
    formik.setFieldValue("selectedProperty", null);
  };

  const getProperties = async () => {
    setState((prev) => ({ ...prev, isLoading: true }));
    try {
      const res = await PropertyApi.getPostProperties({
        page: 1,
        search: state.search,
        listing_type_id: "",
        agents_id: "",
        property_stage_id: "",
        property_type_id: "",
        start_date: "",
        end_date: "",
      });
      if (res?.data?.success) {
        setState((prev) => ({
          ...prev,
          properties: res.data.data.docs,
          isLoading: false,
        }));
      } else {
        toast.error(res?.data?.message || "Failed to fetch properties");
        setState((prev) => ({ ...prev, isLoading: false }));
      }
    } catch (error) {
      toast.error("Error loading properties");
      setState((prev) => ({ ...prev, isLoading: false }));
    }
  };

  useEffect(() => {
    getProperties();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.search]);

    useEffect(() => {
      if (!formik.values.selectedPropertyId) {
        setState((prev) => ({
          ...prev,
          search: "",
          showDropdown: false,
          properties: [],
        }));
      }
    }, [formik.values.selectedPropertyId]);

    useEffect(() => {
      const handleClickOutside = (event: MouseEvent) => {
        if (
          containerRef.current &&
          !containerRef.current.contains(event.target as Node)
        ) {
          setState((prev) => ({ ...prev, showDropdown: false }));
        }
      };
  
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);

  return (
    <div className="agent-contain-container" ref={containerRef}>
      <div className="agent-heading">
        <p>Property</p>
      </div>

      <div className="filter-search-agent">
        <div className="filter-search-icon">
          <SearchIcon />
        </div>
        <input
          type="text"
          placeholder="Search Property"
          className="filter-search-input"
          value={state.search}
          onChange={(e) =>
            setState((prev) => ({
              ...prev,
              search: e.target.value,
              showDropdown: true,
            }))
          }
          onFocus={() => setState((prev) => ({ ...prev, showDropdown: true }))}
        />

        {formik.values.selectedProperty && formik.values.selectedPropertyId && (
          <div className="selected-agent-container">
            <div className="selected-agent">
              <div className="selected-agent-profile-details">
                <p className="selected-agent-profile-name">
                  {formik.values.selectedProperty.name
                    ? `${formik.values.selectedProperty.name}, `
                    : ""}
                  {formik.values.selectedProperty.property_address}
                </p>
              </div>
              <div
                className="selected-agent-remove-icon"
                onClick={removeSelected}
              >
                <RoundRemoveIcon />
              </div>
            </div>
          </div>
        )}

        <div
          className={`filter-down-arrow-icon ${
            state.showDropdown ? "open-box" : ""
          }`}
          onClick={toggleDropdown}
        >
          {state.isLoading ? (
            <CircularProgress
              style={{ width: 20, height: 20, color: "black" }}
            />
          ) : (
            <DownArrowIcon />
          )}
        </div>
      </div>

      <div
        className={`agent-list-container ${
          state.showDropdown ? "" : "display-none"
        }`}
      >
        {(state.properties as Property[]).length > 0 ? (
          (state.properties as Property[]).map((property) => {
            const isActive = formik.values.selectedPropertyId === property._id;
            return (
              <div
                key={property._id}
                className={`agent-list-item ${
                  isActive ? "agent-list-item-active" : ""
                }`}
                onClick={() => onClickSelect(property)}
              >
                <p className="item-profile-name">
                  {property.name ? `${property.name}, ` : ""}
                  {property.property_address}
                </p>
              </div>
            );
          })
        ) : (
          <div className="agent-list-not-found">
            <p>No properties found!</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default FilterPropertySelect;
